import { HttpClient } from "@/App/services/httpClient/HttpClient";
import { name, version } from "../../../package.json";
export const FeedbackService = {
  addFeedback(feedback: string): Promise<object> {
    return HttpClient.post({
      path: `/feedback`,
      body: {
        message: feedback,
        clientInfo: {
          client: name,
          clientVersion: version,
        },
      },
    });
  },
};
